"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.List = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _EncoreContext = require("../../contexts/EncoreContext.js");
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _logging = require("../../logging.js");
var _index = require("../TypeList/index.js");
var _List = require("./List.js");
var _excluded = ["orientation", "hasDividers", "gap"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
// TODO: Remove TypeListProps in v7 and rename NextListProps to ListProps.
// Keeping this in v6 since customers are importing ListProps.
// export type ListProps = TypeListProps;

/**
 * Usage of the current List component is deprecated.
 *
 * In order to use the upcoming `List` component, please use [Encore Context](https://encore.spotify.net/web/components/encore-context) to configure `list` to the `next` lifecycle.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-list--docs) |
 * [Encore site](https://encore.spotify.net/web/components/lists) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/List)
 */
var List = exports.List = /*#__PURE__*/_react["default"].forwardRef(function List(_ref, ref) {
  var orientation = _ref.orientation,
    hasDividers = _ref.hasDividers,
    gap = _ref.gap,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var config = (0, _react.useContext)(_EncoreContext.EncoreContext);
  var status = (0, _EncoreContext.getStatus)(_EncoreContext.encoreContextKeyword.list, config);
  if (status === _EncoreContext.encoreContextStatus.next) {
    return /*#__PURE__*/_react["default"].createElement(_List.ListComponent, Object.assign({
      $orientation: orientation,
      $hasDividers: hasDividers,
      $gap: gap
    }, props, {
      ref: ref,
      "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.List
    }));
  }
  (0, _logging.componentDeprecationWarning)('List', 'TypeList', 'v7', 'Pass the "condensedAll" and "listStyleReset" props in order to achieve the same behavior.');
  return /*#__PURE__*/_react["default"].createElement(_index.TypeList, Object.assign({
    ref: ref,
    condensedAll: true,
    listStyleReset: 'listStyleReset' in props ? props.listStyleReset : true
  }, props));
});